/**
 * US (United States of America)
 * CA (Canada)
 */
import { featuresListByCountryCodeProps } from '@customTypes/PropTypes';

export const americasRegionFeatures: featuresListByCountryCodeProps[] = [
    {
        countryCode: 'US',
        languagePreference: '',
        featuresList: {
            // Explore D&B tile
            isExploreDNBTileEnabled: true,
            exploreDNBTileURL: 'https://{envPrefix}.dnb.com/products/small-business.html?utm_source=dnb_customer_portal&utm_medium=explore_products',
            // Market Place section
            isMarketPlaceSectionEnabled: true,
            marketPlaceSectionURL: 'https://{envPrefix}.dnb.com/marketplace/product.html',
            // Company Details
            isAddCompanyCTAEnabled: true,
            addCompanyCTAURL: 'https://{envPrefix}.dnb.com/duns-number/get-a-duns.html',
            isUpdatedInfoCTAEnabled: true,
            updatedInfoCTAURL: 'https://dashboard{envPrefix}.com/?redirect_url=view_edit&query={encodedDunsNumber}',
            isViewPublicProfileCTAEnabled: true,
            viewPublicProfileCTAURL: '',
            // Learning center
            isLearningCenterEnabled: true,
            learningCenterURL: 'https://www.dnb.com/resources.html',
            // Support
            isSupportEnabled: true,
            supportURL: 'https://service.dnb.com/home?TAB_ID=TAB_02',
            // Cancel renewal
            isCancelRenewalEnabled: true,
            isCancelrenewalSupportThroughEmail: false,
            cancelRenewalURL: 'https://{envPrefix}.dnb.com/en-us/product?reason=Cancel Contract or my Subscription&cust_details=',

            //  Recommended Products
            isRecommendedProductsEnabled: true,
            // Terms of Use
            termsOfUseURL: 'https://www.dnb.com/utility-pages/terms-of-use.html',
            // Privacy Policy
            privacyPolicyURL: 'https://www.dnb.com/utility-pages/privacy-policy.html',
            // Deals and offers
            isDealsOffersEnabled: true,
            // Recommended Service Section
            isRecommendedServiceEnabled: true,
            // My Business Overview Section only for CM UKI
            isBusinessOverviewEnabled: false,
            // Trust Centre link
            trustCentre: 'https://www.dnb.com/about-us/data-transparency.html',
        },
    },
    {
        countryCode: 'CA',
        languagePreference: '',
        featuresList: {
            // Explore D&B tile
            isExploreDNBTileEnabled: true,
            exploreDNBTileURL: 'https://{envPrefix}.dnb.com/ca-en/products/small-business.html?utm_source=dnb_customer_portal&utm_medium=explore_products',
            // Market Place section
            isMarketPlaceSectionEnabled: false,
            marketPlaceSectionURL: '',
            // Company Details
            isAddCompanyCTAEnabled: true,
            addCompanyCTAURL: 'https://{envPrefix}.dnb.com/ca-en/duns-number/get-a-duns.html',
            isUpdatedInfoCTAEnabled: false,
            updatedInfoCTAURL: '',
            isViewPublicProfileCTAEnabled: false,
            viewPublicProfileCTAURL: '',
            // Learning center
            isLearningCenterEnabled: true,
            learningCenterURL: 'https://www.dnb.com/resources.html',
            // Support
            isSupportEnabled: true,
            supportURL: 'https://service.dnb.com/home?TAB_ID=TAB_02',
            // Cancel renewal
            isCancelRenewalEnabled: true,
            isCancelrenewalSupportThroughEmail: false,
            cancelRenewalURL: 'https://service.dnb.com/en-us/home?TAB_ID=TAB_02',

            //  Recommended Products
            isRecommendedProductsEnabled: false,
            // Terms of Use
            termsOfUseURL: 'https://www.dnb.com/ca-en/utility-pages/terms-of-use.html',
            // Privacy Policy
            privacyPolicyURL: 'https://www.dnb.com/ca-en/utility-pages/privacy-policy.html',
            // Deals and offers
            isDealsOffersEnabled: false,
            // Recommended Service Section
            isRecommendedServiceEnabled: false,
            // My Business Overview Section only for CM UKI
            isBusinessOverviewEnabled: false,
            // Trust Centre link
            trustCentre: 'https://www.dnb.com/about-us/data-transparency.html',
        },
    },
];
